import { Component, OnInit } from '@angular/core';
import { SwaggerUIBundle } from 'swagger-ui-dist';
import { protectedResources } from '../../auth-config';
import { MsalService } from '@azure/msal-angular';
import { User } from 'src/app/models/user';

//declare const SwaggerUIBundle: any;

@Component({
  selector: 'app-swagger-interface-v2',
  templateUrl: './swagger-interface-v2.component.html',
  styleUrls: ['./swagger-interface-v2.component.scss'],
  standalone: false,
})
export class SwaggerInterfaceV2Component implements OnInit {

  constructor(
    private authService: MsalService,
    private user: User) {
    this.activeUser = user;
    this.msalService = authService;
  }

  private cachedToken: string;
  private msalService: MsalService;
  private activeUser: User;

  ngOnInit(): void {

    this.msalService.instance.acquireTokenSilent(protectedResources.LOSTalkerAPI).then(value => {
      this.cachedToken = value.accessToken;
    });

    // eslint-disable-next-line unused-imports/no-unused-vars
    const ui = SwaggerUIBundle({
      dom_id: '#swagger-ui',
      layout: 'BaseLayout',
      presets: [
        SwaggerUIBundle.presets.apis,
        SwaggerUIBundle.SwaggerUIStandalonePreset,
      ],
      url: 'assets\\sw_v2-202610200310.json',
      defaultModelsExpandDepth: -1,
      docExpansion: 'none',
      operationsSorter: 'alpha',
      requestInterceptor: (req) => {
        req.headers['Authorization'] = 'Bearer ' + this.cachedToken;
        return req;
      },
    });
  }

}
